document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pw-product]').forEach((root) => {
    const dataNode = root.querySelector('[data-pw-variants]');
    if (!dataNode) return;

    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (error) { return; }

    const hiddenId = root.querySelector('[data-pw-variant-id]');
    const addButtons = root.querySelectorAll('[data-pw-add], .pw-product-v161__quick-add, .pw-product-v161__final-buy button');
    const prices = root.querySelectorAll('[data-pw-price]');
    const mainImage = root.querySelector('[data-pw-main-image]');
    const message = root.querySelector('[data-pw-variant-message]');
    const stock = root.querySelector('[data-pw-stock]');

    const money = (cents) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const selectedValues = () => Array.from(root.querySelectorAll('[data-pw-option]')).map((group) => {
      const checked = group.querySelector('input:checked');
      return checked ? checked.value : '';
    });

    const update = () => {
      const values = selectedValues();
      const variant = variants.find((item) => item.options.every((option, index) => String(option) === String(values[index])));
      root.querySelectorAll('[data-pw-option]').forEach((group) => {
        group.querySelectorAll('.pw-product-v161__choice').forEach((choice) => choice.classList.toggle('is-selected', choice.querySelector('input').checked));
        const label = group.querySelector('[data-pw-option-label]');
        const checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });

      if (!variant) {
        addButtons.forEach((button) => { button.disabled = true; });
        if (message) message.textContent = 'Deze combinatie is niet beschikbaar.';
        if (stock) { stock.classList.add('is-unavailable'); stock.querySelector('b').textContent = 'Niet beschikbaar'; stock.querySelector('small').textContent = 'Kies een andere combinatie'; }
        return;
      }

      if (hiddenId) hiddenId.value = variant.id;
      prices.forEach((node) => { node.textContent = money(variant.price); });
      addButtons.forEach((button) => {
        button.disabled = !variant.available;
        if (button.hasAttribute('data-pw-add')) button.textContent = variant.available ? 'Voeg toe aan winkelwagen' : 'Uitverkocht';
      });
      if (message) message.textContent = variant.available ? '' : 'Deze uitvoering is momenteel uitverkocht.';
      if (stock) {
        stock.classList.toggle('is-unavailable', !variant.available);
        stock.querySelector('b').textContent = variant.available ? 'Op voorraad' : 'Uitverkocht';
        stock.querySelector('small').textContent = variant.available ? 'Veilig besteld en snel verzonden' : 'Kies een andere uitvoering';
      }

      const imageSource = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
      if (mainImage && imageSource) mainImage.src = imageSource;
      if (window.history && window.history.replaceState) window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
    };

    root.querySelectorAll('[data-pw-option] input').forEach((input) => input.addEventListener('change', update));
    root.querySelectorAll('[data-pw-property-choice] input').forEach((input) => input.addEventListener('change', () => {
      const group = input.closest('[data-pw-property-choice]');
      const label = group && group.querySelector('[data-pw-property-label]');
      if (label) label.textContent = input.value;
    }));
    root.querySelectorAll('[data-pw-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      if (mainImage) mainImage.src = thumb.dataset.image;
      root.querySelectorAll('[data-pw-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    }));
    update();
  });
});
